import Axios from "axios";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";

const CustomerDebts = () => {

  const colors = tokens;

  const [data, setData] = useState([]);

  useEffect(() => {

    Axios.get("https://store.petplanet.rw/api/outstanding-debts")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
    
  }, []);
  

  const columns = [

    {
      field: "customer_name",
      headerName: "Customer",
      flex: 1,
    },

    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },

    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      renderCell: (params) => {

        const value = parseFloat(params.value);
        const formatted = isNaN(value) ? "0" : value.toLocaleString();

        return (
          <Box>
            {formatted}
            <span style={{ color: colors.blueAccent[300], marginLeft: 5 }}>RWF</span>
          </Box>
        );
      }
    },

    {
      field: "paid_amount",
      headerName: "Paid",
      flex: 1,
      renderCell: (params) => {

        const value = parseFloat(params.value);
        const formatted = isNaN(value) ? "0" : value.toLocaleString();

        return (
          <Box>
            {formatted}
            <span style={{ color: colors.blueAccent[300], marginLeft: 5 }}>RWF</span>
          </Box>
        );
      }
    },

    {
      field: "balance",
      headerName: "Balance",
      flex: 1,
      renderCell: (params) => {

        const value = parseFloat(params.value);
        const formatted = isNaN(value) ? "0" : value.toLocaleString();

        return (
          <Box>
            {formatted}
            <span style={{ color: "#fbc02d", marginLeft: 5 }}>RWF</span>
          </Box>
        );
      }
    },

    {
      field: "due_date",
      headerName: "Due Date",
      flex: 1,
      renderCell: (params) => {
        if (!params.value) return "";
        return new Date(params.value).toLocaleDateString();
      }
    },
  ];

  return (
    <Box m="20px" mt="80px">

      <Header title="Customer Debts" subtitle="1,000 customers with debts" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
           "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
                      border: "none",
                      color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
        }}
      >

        <DataGrid
          rows={data}
          columns={columns}
          checkboxSelection
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />

      </Box>

    </Box>
  );
};

export default CustomerDebts;